import useSubscription from 'Core/Subscription/useSubscription';
import React from 'react';
import { useHistory } from 'react-router-dom';

function ClearLocalStorage(): JSX.Element {
    const { clearUser } = useSubscription();
    const { push } = useHistory();

    React.useEffect(() => {
        clearUser();
        push('/login');
    }, []);

    return <></>;
}

export default ClearLocalStorage;
